<template>
  <div class="proect">
    <div class="container content_p">
      <div style="height: 0.25rem">
        <div class="top_progress">
          <el-progress :percentage="percentage"></el-progress>
        </div>
      </div>
      <div class="info">
        <div>
          <Chart>
            <h4 slot="title">教育经历（必填）：</h4>
            <div slot="tab">
              <div v-if="contents">
                <el-empty description="暂无数据，请新增"></el-empty>
              </div>
              <div class="lists">
                <div
                  class="list"
                  v-for="(item, index) in EducationList"
                  :key="index"
                >
                  <div class="list_h">
                    <h5>{{ item.school }} {{ item.professional }}</h5>
                  </div>
                  <div class="list_p">
                    <p>
                      {{ item.start_time }}至{{ item.end_time }}
                      <!-- {{ item.degree }} -->
                    </p>
                  </div>

                  <div class="xg">
                    <el-link
                      icon="el-icon-edit"
                      @click="editCert(item)"
                      style="margin-right: 20px"
                      >修改</el-link
                    >
                    <el-link icon="el-icon-delete" @click="RejPush(item.j_e_id)"
                      >删除</el-link
                    >
                  </div>
                </div>
              </div>
              <div class="PushList">
                <el-button @click="pushlist">新增一条</el-button>
              </div>
            </div>
          </Chart>
        </div>
        <div class="PushBox b-r" v-show="show">
          <el-form :model="form" :rules="rules" ref="form">
            <div class="box_top">
              <div class="box_list">
                <el-form-item prop="school">
                  <el-input
                    placeholder="学校名称："
                    v-model="form.school"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="box_list time_box">
                <div>
                  <el-form-item prop="start_time">
                    <el-date-picker
                      v-model="form.start_time"
                      type="date"
                      placeholder="开始日期"
                      format="yyyy 年 MM 月"
                      value-format="yyyy-MM"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
                <span>至</span>
                <div>
                  <el-form-item prop="end_time">
                    <el-date-picker
                      v-model="form.end_time"
                      type="date"
                      placeholder="结束日期"
                      format="yyyy 年 MM 月"
                      value-format="yyyy-MM"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <div class="box_list">
                <el-form-item prop="professional">
                  <el-input
                    placeholder="专业名称："
                    v-model="form.professional"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="box_list">
                <el-form-item prop="degree">
                  <el-select
                    placeholder="学制："
                    v-model="form.degree"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in $common.degrees"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="box_btm"></div>
            <div class="tj">
              <el-button type="success" :plain="true" @click="ResPush('form')"
                >提交</el-button
              >
              <el-button :plain="true" @click="Cancel">取消</el-button>
            </div>
          </el-form>
        </div>
        <div style="height: 0.25rem"></div>
        <div class="sub">
          <el-button @click="backBtn">返回上一步</el-button>
          <el-button
            type="success"
            v-if="!isUpdate"
            @click="nextPage('/user/language')"
            >继续完善语言能力</el-button
          >
        </div>

        <div style="height: 0.25rem"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "@/components/Chart.vue";
import StepJs from "../mixins/step";
export default {
  props: {},
  mixins: [StepJs],
  data() {
    return {
      percentage: 37.5,
      show: false,
      isUpdate: false,
      contents: true,
      form: {
        type: "jobEducate",
        school: "",
        professional: "",
        degree: "",
        start_time: "",
        end_time: "",
      },
      degrees: [
        {
          value: "0",
          label: "请选择学历",
        },
        {
          value: "1",
          label: "小学",
        },
        {
          value: "2",
          label: "初中",
        },
        {
          value: "3",
          label: "高中",
        },
        {
          value: "4",
          label: "中专",
        },
        {
          value: "5",
          label: "大专 统招",
        },
        {
          value: "6",
          label: "大专 成教",
        },
        {
          value: "7",
          label: "本科 统招",
        },
        {
          value: "8",
          label: "本科 成教",
        },
        {
          value: "9",
          label: "硕士",
        },
        {
          value: "10",
          label: "博士",
        },
      ],
      EducationList: [],
      rules: {
        school: [
          { required: true, message: "请输入学校名称", trigger: "blur" },
        ],
        // professional: [
        //   { required: true, message: "请输入专业名称", trigger: "blur" },
        // ],
        start_time: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        end_time: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
        ],
        degree: [{ required: true, message: "请输入学制", trigger: "blur" }],
      },
    };
  },
  computed: {},
  created() {
    setTimeout(this.timer, 500);
    if (this.$query().actions == "edit") {
      this.isUpdate = true;
    }
    this.getjobUser();
  },
  mounted() {},
  watch: {},
  methods: {
    timer() {
      this.percentage = 50;
    },
    // 切换表单内容的显示隐藏
    pushlist() {
      this.show = true;
    },
    // 修改操作
    editCert(item) {
      this.show = true;
      this.form = { ...item };
    },
    // 取消
    Cancel() {
      this.show = false;
    },

    // 读取信息
    // 页面创建后调用的用户已有信息显示
    getjobUser() {
      let j_l_id = this.$store.state.user.userInfo.user.user_id;
      console.log(j_l_id);
      // 如果有j——id就显示用户简历里面的信息，否则显示vuex里面已有信息
      if (j_l_id) {
        this.$http
          .get(this.$api.getResumeDetails + j_l_id + "/" + "jobEducate")
          .then((res) => {
            //console.log(res.content);
            if (res.content == "") {
              this.contents = true;
            } else {
              this.contents = false;
              this.EducationList = res.content;
            }
          });
      } else {
        console.log("无数据");
      }
    },
    ResPush(form) {
      // element表单 验证
      this.$refs[form].validate((valid) => {
        if (valid) {
          // 创建简历
          this.form.type = "jobEducate";
          this.$http
            .post(this.$api.createResume, this.form, true)
            .then((res) => {
              console.log(res);
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$store.dispatch("user/getInfo").then(() => {
                this.getjobUser();
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      // 表单项为空则保持在表单填写页面，否则push表单内容后隐藏表单页面
      if (
        this.form.school == "" ||
        this.form.professional == "" ||
        this.form.degree == "" ||
        this.form.start_time == "" ||
        this.form.end_time == ""
      ) {
        this.show = true;
      } else {
        // 深拷贝form表单内容后清除form内容
        let obj = { ...this.form };
        this.EducationList.push(obj);
        this.form.school = "";
        this.form.professional = "";
        this.form.degree = "";
        this.form.start_time = "";
        this.form.end_time = "";
        this.show = false;
      }
    },
    RejPush(j_l_id) {
      let p_id = j_l_id;
      // 删除经历
      this.$http
        .post(this.$api.delResume + p_id + "/" + "jobEducate")
        .then((res) => {
          console.log(res);
          this.$store.dispatch("user/getInfo").then(() => {
            this.getjobUser();
          });
          this.$router.go(0);
        });
    },
  },
  components: {
    Chart,
  },
};
</script>

<style lang="less" scoped>
.tab {
  .lists {
    .list {
      padding: 0.2rem 0;
      border-bottom: 1px solid #bebebe;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .list_h {
        width: 50%;
      }
      .list_p {
        width: 50%;
      }
      p {
        font-size: 0.14rem;
        color: #333;
        line-height: 0.3rem;
      }
    }
  }
  .PushList {
    margin: 0.2rem 0;
  }
}
.PushBox {
  padding: 0.2rem 0.13rem;
  width: 100%;
  margin-top: 0.2rem;
  .box_top {
    display: flex;
    flex-wrap: wrap;
    .box_list {
      width: 50%;
      padding: 0 0.2rem;
      margin-bottom: 0.2rem;
    }
    .time_box {
      display: flex;
      align-items: center;
      div {
        width: 100%;
      }
    }
  }
  .box_btm {
    padding: 0 0.2rem;
  }
  .tj {
    padding: 0 0.2rem;
    margin-top: 0.2rem;
  }
}
.sub {
  display: flex;
  justify-content: center;
}
@media only screen and (max-width: 766px) {
  .proect {
    min-height: 7rem;
  }
  .tab {
    .lists {
      .list {
        p {
          font-size: 0.24rem;
        }
      }
    }
  }
  .PushBox {
    .box_top {
      .box_list {
        width: 100%;
      }
    }
  }
  .xg {
    width: 20%;
  }
}
</style>
